import React, { useState } from 'react';
import { MapPin, User, LogOut } from 'lucide-react';
import { UserLocation } from '../types';
import { useAuth } from '../context/AuthContext';
import { AuthModal } from './Auth/AuthModal';

interface HeaderProps {
  userLocation: UserLocation | null;
}

export const Header: React.FC<HeaderProps> = ({ userLocation }) => {
  const { user, signOut } = useAuth();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://i.ibb.co/xKYr1D9P/Group-1211720.png" 
              alt="Мой Куток" 
              className="h-12 w-auto"
            />
          </div>
          
          <div className="flex items-center gap-4">
            {userLocation && (
              <div className="flex items-center gap-2 text-gray-600">
                <MapPin size={20} />
                <span>{userLocation.city}</span>
              </div>
            )}

            {user ? (
              <div className="flex items-center gap-2">
                <div className="flex items-center gap-2 px-4 py-2 bg-gray-100 rounded-full">
                  <User size={20} className="text-gray-600" />
                  <span className="text-gray-600">{user.email}</span>
                </div>
                <button
                  onClick={() => signOut()}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                  title="Выйти"
                >
                  <LogOut size={20} className="text-gray-600" />
                </button>
              </div>
            ) : (
              <button
                onClick={() => setIsAuthModalOpen(true)}
                className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-full hover:bg-primary/90 transition-colors"
              >
                <User size={20} />
                <span>Войти</span>
              </button>
            )}
          </div>
        </div>
      </div>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </header>
  );
};